import { StylesProvider, ThemeProvider } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import theme from '../theme';
import createGenerateClassName from './fork-create-generate-class-name';

const generateClassName = createGenerateClassName();

export function MuiProviders(props) {
  const { children } = props;

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider generateClassName={generateClassName}>{children}</StylesProvider>
    </ThemeProvider>
  );
}

MuiProviders.propTypes = {
  children: PropTypes.node.isRequired,
};
